import { SelectMenu, Typography } from '@scale/scaleui';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useFilteredPodTypeOptions } from 'react-scale/components/ExpertManagement/hooks/useFilteredPodTypeOptions';
import {
  DateRangeOptions,
  StatContextState,
  dateRangeSelector,
  podTypeFilterSelector,
  projectSelector,
  setDateRangeSelector,
  setPodTypeFilterSelector,
  setProjectSelector,
  useStatContextStore,
} from 'react-scale/components/ExpertManagement/stores/statContext.store';
import SelectProject from 'react-scale/corp/components/UI/SelectProject/SelectProject';
import useQueryParams from 'react-scale/corp/hooks/useQueryParams';
import { shallow } from 'zustand/shallow';

const selectors = (state: StatContextState) => ({
  dateRange: dateRangeSelector(state),
  setDateRange: setDateRangeSelector(state),
  project: projectSelector(state),
  setProject: setProjectSelector(state),
  podTypeFilter: podTypeFilterSelector(state),
  setPodTypeFilter: setPodTypeFilterSelector(state),
});

export function StatContextSelector() {
  const { dateRange, setDateRange, project, setProject, podTypeFilter, setPodTypeFilter } =
    useStatContextStore(selectors, shallow);
  const params = useQueryParams();
  const history = useHistory();
  const location = useLocation();

  const availablePodTypes = useFilteredPodTypeOptions();

  const filteredPodTypes = useMemo(
    () => availablePodTypes.sort((a, b) => a.name.localeCompare(b.name)),
    [availablePodTypes],
  );

  const showPodTypeSelector = !params.user && filteredPodTypes.length !== 1;

  return (
    <div className="flex items-center gap-2">
      <Typography.Paragraph2 className="font-medium">Show stats for</Typography.Paragraph2>
      <SelectMenu
        selectedOptionId={dateRange}
        setSelected={r => setDateRange(r)}
        options={DateRangeOptions}
      />
      <Typography.Paragraph2 className="font-medium">filtered by project</Typography.Paragraph2>
      <SelectProject placeholder="All Projects" value={project} onChange={setProject} />
      {showPodTypeSelector && (
        <>
          <Typography.Paragraph2 className="font-medium">
            filtered by pod type
          </Typography.Paragraph2>
          <SelectMenu
            selectedOptionId={podTypeFilter}
            setSelected={r => {
              history.push({
                pathname: location.pathname,
                search: `?podType=${r}`,
              });
              setPodTypeFilter(r);
            }}
            options={filteredPodTypes}
          />
        </>
      )}
    </div>
  );
}
